import FormDataUtils from "@/utils/form-data";
import Validator from "validatorjs";

window.Form = function (
    data,
    veeErrors = null,
    veeErrorsScope = null,
    rules = null,
    attributes = null,
    customErrorMessages = null
) {
    let form = this;
    let original_data = _.cloneDeep(data);

    window.$.extend(this, data);

    /**
     * Create the form error helper instance.
     */
    this.veeErrors = veeErrors;
    this.veeErrorsScope = veeErrorsScope;
    this.errors = new window.FormErrors(this.veeErrors, this.veeErrorsScope);
    this.form_rules = rules;
    this.busy = false;
    this.successful = false;

    this.getFormData = function (fields = null) {
        let temp = {};
        _.forOwn(this, (item, key) => {
            if (
                _.includes(
                    ["veeErrors", "errors", "busy", "successful", "form_rules"],
                    key
                ) ||
                typeof item === "function" ||
                (item && item.call && item.apply)
            ) {
                return;
            }
            if (fields && !_.includes(fields, key)) {
                return;
            }
            temp[key] = item;
        });
        let form_data = FormDataUtils.objectToFormData(temp);
        for (let pair of form_data.entries()) {
            if (_.includes(["true", "false", true, false], pair[1])) {
                form_data.set(
                    pair[0],
                    pair[1] === true || pair[1] === "true" ? 1 : 0
                );
            }
        }
        return form_data;
    };

    this.feedback = function (field) {
        return {
            "is-danger": this.errors.has(field),
        };
    };

    this.state = function (field) {
        if (Array.isArray(field)) {
            let hasError = false;
            _.forEach(field, (item) => {
                if (this.errors.has(item)) {
                    hasError = true;
                    return false;
                }
            });
            return {
                "is-error": hasError,
            };
        } else {
            return {
                "is-error": this.errors.has(field),
            };
        }
    };

    function htmlEncode(value) {
        return window.$("<div/>").text(value).html();
    }

    this.help = function (field) {
        if (!this.errors.has(field)) return;
        return `<small class="form-help u-color-danger">${this.errors.get(
            field
        )}</small>`;
    };

    /**
     * Start processing the form.
     */
    this.startProcessing = function () {
        form.errors.forget();
        form.busy = true;
        form.successful = false;
    };

    /**
     * Finish processing the form.
     */
    this.finishProcessing = function (success = true) {
        form.busy = false;
        form.successful = success;
    };

    /**
     * Reset the errors and other state for the form.
     */
    this.resetStatus = function () {
        form.errors.forget();
        form.busy = false;
        form.successful = false;
    };

    /**
     * Set the errors on the form.
     */
    this.setErrors = function (errors) {
        form.busy = false;
        form.errors.set(errors);
    };

    this.clearFields = function () {
        this.resetStatus();
        window.$.extend(this, _.cloneDeep(original_data));
    };

    this.setVeeErrors = function (veeErrors, scope = null) {
        Vue.set(this, "veeErrors", veeErrors);
        Vue.set(this, "veeErrorsScope", scope);
        Vue.set(this.errors, "veeErrors", veeErrors);
        Vue.set(this.errors, "veeErrorsScope", scope);
    };

    this.validate = function () {
        let validator = new Validator(
            this,
            this.form_rules,
            customErrorMessages
        );
        if (attributes) {
            validator.setAttributeNames(attributes);
        }
        let passes = validator.passes();
        this.errors.set(validator.errors.errors);
        return passes;
    };
};
